import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import './Features.scss';

export default function Features() {
  const { t } = useI18n();
  const items = t('videoGeneration.wan.features.items');
  return (
    <section className="wan-features">
      <div className="wan-features__inner">
        <h2>{t('videoGeneration.wan.features.title')}</h2>
        <div className="wan-features__grid">
          {items.map((i) => (
            <div key={i.num} className="wan-feature">
              <div className="wan-feature__num">{i.num}</div>
              <h3>{i.title}</h3>
              <p>{i.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}